<template>
  <v-app dark>
    <Navigation @page="page" />
    <UserBanner :headTitle="section"/>
    <component :is="section" />
    <v-footer :absolute="true" app>
      <span>&copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
  </v-app>
</template>

<script>
import Navigation from "../components/Menus/Navigation";
import UserBanner from "../components/Menus/UserBanner";
import AppIndex from "../contents/AppIndex";
import Suppliers from "../contents/Suppliers";
import Customers from "../contents/Customers";
import Products from "../contents/Products";
import Stock from "../contents/Stock";
import Factory from "../contents/Factory";
export default {
  components: {
    Navigation,
    UserBanner,
    AppIndex,
    Suppliers,
    Customers,
    Products,
    Stock,
    Factory
  },
  data() {
    return {
      section: "AppIndex",
    };
  },
  created() {
    if (this.$route.params.section) {
      this.section = this.$route.params.section;
    }
  },
  methods: {
    page(val) {
      this.section = val
    },
  },
};
</script>

<style scoped>
</style>